export default __webpack_public_path__ + "static/olympicPark1-2384a08f52d12ac64ab3edeaca573ae1.jpeg";